import { transition } from '@helpers/animation';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import styled, { css } from 'styled-components';
const Text = styled.div ``;
export const PrimaryStyles = css `
  border: 2px solid ${brand.primary.blue.base};
  background-color: ${brand.primary.blue.base};
  color: ${brand.white};

  &:focus-visible,
  &:hover {
    border-color: var(--hoverColor, ${brand.primary.blue.light}) !important;
    background-color: var(--hoverColor, ${brand.primary.blue.light}) !important;
    color: ${brand.white};
  }

  &:active {
    border-color: ${brand.primary.blue.base};
    background-color: ${brand.primary.blue.base};
    color: ${brand.white};
  }
`;
export const SecondaryStyles = css `
  background-color: transparent;
  color: ${brand.white};
  border: 2px solid ${brand.white};

  &:focus-visible,
  &:hover,
  &:active {
    border-color: ${brand.primary.blue.light};
    background-color: ${brand.primary.blue.light};
    color: ${brand.white};
  }
`;
export const TertiaryStyles = css `
  background-color: ${brand.white};
  color: ${brand.black};
  border: 2px solid ${brand.white};

  &:focus-visible,
  &:hover {
    border-color: ${brand.primary.blue.base};
    background-color: ${brand.primary.blue.base};
    color: ${brand.white};
  }

  &:active {
    border-color: ${brand.white};
    background-color: ${brand.primary.blue.base};
    color: ${brand.white};
  }
`;
export const OutlineStyles = css `
  background-color: ${brand.white};
  color: ${brand.primary.blue.base};
  border: 2px solid ${brand.primary.blue.base};

  &:focus-visible,
  &:hover,
  &:active {
    border-color: ${brand.primary.blue.light};
    background-color: ${brand.primary.blue.light};
    color: ${brand.white};
  }
`;
export const TransparentStyles = css `
  background-color: transparent;
  color: ${brand.white};
  border: 2px solid ${brand.white};

  &:focus-visible,
  &:hover,
  &:active {
    border-color: ${brand.white};
    background-color: ${brand.primary.blue.base};
    color: ${brand.white};
  }
`;
const IconLeft = css `
  padding-right: 15px;

  @media ${until(Device.DesktopSmall)} {
    padding-right: 0;
  }
`;
const IconRight = css `
  padding-left: 15px;

  @media ${until(Device.DesktopSmall)} {
    padding-left: 0;
  }
`;
const hideText = css `
  ${Text} {
    @media ${until(Device.DesktopSmall)} {
      display: none;
    }
  }
`;
const Icon = styled.div `
  display: inline-block;
  vertical-align: middle;

  ${({ position }) => {
    switch (position) {
        case 'left':
            return IconLeft;
        case 'right':
            return IconRight;
        default:
            break;
    }
}}

  svg {
    max-height: 24px;
    width: 20px;
  }
`;
export const BaseButtonStyles = css `
  ${transition('color, background-color, border-color')};

  display: inline-flex;
  align-items: center;
  border-radius: 25px;
  height: 50px;
  justify-content: center;
  padding: 0 32px;
  text-decoration: none;
  user-select: none;
  white-space: nowrap;
`;
export const ButtonTextStyles = css `
  ${fonts.inter.semiBold};

  font-size: 16px;
  line-height: 26px;
  text-transform: uppercase;
  transform: translateY(-2px);
  vertical-align: middle;

  @media ${until(Device.TabletLarge)} {
    font-size: 12px;
    line-height: 20px;
    white-space: break-spaces;
    text-align: center;
  }
`;
const Button = styled.button `
  ${BaseButtonStyles};

  ${Text} {
    ${ButtonTextStyles};

    display: inline-block;
  }

  ${({ branding }) => {
    switch (branding) {
        case 'primary':
            return PrimaryStyles;
        case 'secondary':
            return SecondaryStyles;
        case 'tertiary':
            return TertiaryStyles;
        case 'outline':
            return OutlineStyles;
        case 'transparent':
            return TransparentStyles;
        default:
            break;
    }
}}

  ${({ iconPosition }) => {
    switch (iconPosition) {
        case 'right':
            return hideText;
        default:
            break;
    }
}}

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;
export const ButtonStyles = {
    Button,
    Icon,
    Text,
};
